import styled, { css } from 'styled-components';

import { Color, Font, theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type HtmlContentProps = {
  html: string;
  font?: Font;
  color?: Color;
};

export const htmlContentStyles = css`
  color: ${theme.color.textPrimary};
  overflow-wrap: break-word;

  p {
    margin: 0;
    padding: 0;

    &:empty {
      padding: ${pxToRem(12)} 0;
    }
  }

  /*
   * Markers stay outside the content box. With them inside they take up inline
   * space on the first line, so wrapped lines start to the left of the marker
   * instead of lining up under the text (ENG-510).
   */
  ol,
  ul {
    margin: ${pxToRem(4)};
    list-style-position: outside;
  }

  li > p {
    display: inline;
  }

  a {
    color: ${theme.color.elementBlue100};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const HtmlContent = ({ html, font = 'regular16', color }: HtmlContentProps) => {
  return <Content $font={font} $color={color} dangerouslySetInnerHTML={{ __html: html }} />;
};

const Content = styled.div<{ $font: Font; $color?: Color }>`
  font: ${({ $font }) => theme.font[$font]};
  ${htmlContentStyles}
  ${({ $color }) =>
    $color &&
    css`
      &,
      & *:not(a) {
        color: ${theme.color[$color]};
      }

      & a,
      & a * {
        color: ${theme.color.elementBlue100};
      }
    `}
`;
